<template>
   <div
    v-if="showComponent"
    id="lm-button-root-wrapper"
    class="form-group"
    @click="stopPropagation"
    :class="[
      lmButtonRootWrapperClass,
      {'avoid-pointer-events': this.isProcessing}
      ]"
    >
    <div
      id="lm-button-wrapper"
      :class="[
          lmButtonWrapperClass
        ]"
        class="pl-0"
        @click="stopPropagation"
      >
      <button
        :id="id"
        ref="lmButton"
        :type="type"
        :disabled="isDisabled"
        :style="{width: buttonWidth, height: buttonHeight}"
        :class="[
          buttonClass,
          {'btn-info': !buttonClass && !disabled},
          {disabled: disabled},
          {'btn-lg': size === 'lg', 'btn-sm': size === 'sm'},
          [iconPosition === 'left' ? 'justify-content-center' : 'flex-row-reverse']
        ]"
        class="btn d-flex align-items-center position-relative text-lg"
        @click="onClick()"
        >
          <font-awesome-icon
            v-if="icon && !isProcessing"
            id="font-awesome-icon-edit"
            :icon="icon"
            :class="[iconPosition === 'left' ? 'mr-2' : 'ml-2']"
          />
          <LmSpinnerBorder @click="stopPropagation" class="lm-spinner-border" v-if="isProcessing"/>
          <span @click="stopPropagation" :class="{invisible: isProcessing}">{{text}}</span>
        </button>
    </div>
    <b-tooltip @click="stopPropagation" v-if="showTooltip" target="lm-button-wrapper" placement="top">
      {{tooltip.value}}
    </b-tooltip>
    <LmConfirmationModal id="confirmationModal" ref="confirmationModal" :title="confirmationTitle" :message="confirmationMessage"  @ok="$emit('click')" />
  </div>
</template>

<script>
import LmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'
import LmSpinnerBorder from '@/components/LmSpinnerBorder'

// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  data () {
    return {
      buttonWidth: null,
      buttonHeight: null
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || this.isProcessing
    },
    showTooltip () {
      if (this.tooltip) {
        if (this.tooltip.showOnlyOnDisabled && this.tooltip.value) {
          return this.disabled
        } else {
          return this.tooltip.value
        }
      }
    },
    text () {
      return this.value
    }
  },
  props: {
    type: {
      type: String,
      default: 'button'
    },
    buttonClass: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    tooltip: {
      type: Object
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    lmButtonWrapperClass: {
      type: String
    },
    lmButtonRootWrapperClass: {
      type: String
    },
    icon: {
      type: String,
      default: ''
    },
    iconPosition: {
      type: String,
      default: 'left'
    },
    action: {
      type: String,
      default: 'submit'
    },
    requireConfirmation: {
      type: Boolean,
      default: false
    },
    confirmationTitle: {
      type: String,
      default: function () {
        return this.$t('cannot_be_undone')
      }
    },
    confirmationMessage: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  components: {
    LmSpinnerBorder,
    LmConfirmationModal
  },
  methods: {
    async onClick (event) {
      try {
        if (this.action === 'delete' || this.requireConfirmation) {
          await this.$refs.confirmationModal.lmShow()
        } else {
          this.$emit('click')
        }
      } catch (error) {
        console.log(error)
      }
    },
    stopPropagation (event) {
      if (this.isDisabled) {
        event.stopPropagation()
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  .btn
    white-space: nowrap
    // box-shadow: $button-shadow
    padding: 0.3rem 0.6rem !important;
    box-shadow: none !important;
  .lm-spinner-border
    position: absolute
    top: 25%
    bottom: 0
    left: 0
    right: 0
    z-index: 9999
    margin: 0 auto
</style>
